var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxFilesystemViewerActionsBase',{scopedSlots:_vm._u([{key:"node-name",fn:function(){return [_c('span',{staticClass:"node-name__content"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }